import SectionBase from 'src/api/sections/base'

export default class Tags extends SectionBase {
  public getTags = () =>
    this.service.request({
      url: '/v2/library/tags',
      method: 'GET',
    })
}
